import { getBasePath } from '../../../modules/header';
import DefaultSettings from '../../../controls/components/settings';


export const getxAccessKey = () => {
    return localStorage.getItem('xaccesstoken') || null;
};

export const getxAccessKeyConditional = (evt) => {
    return getxAccessKey();
};

export const getHeaders = (evt, contentType = 'application/json') => {
    return {
        'Cache-Control': 'no-store,no-cache',
        'Pragma': 'no-cache',
        'x-access-key': getxAccessKey(),
        'Content-Type': contentType,
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept, Authorization",
        "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Credentials": "true"
    };
};


const handleResponse = async (response, url, alert, message, isLoader, method, bodyval) => {
    const loader = DefaultSettings.getLoader();
    const alertInstance = DefaultSettings.getAlert();

    if (response.ok) {       
        loader && isLoader && loader.remove();
        alertInstance && alert && alertInstance.show(message || "Saved Successfully", 'success');
        return response.json();
    } else if (response.status === 401) {
        window.location.replace(getBasePath() + 'unauthorize');
        throw response.json();
    }  else {
        loader && isLoader && loader.remove();
        alertInstance && alertInstance.show("Verify Validations/Errors" || 'Error Occurred', 'error');
        throw response.json();
    }
};

export const plugin_asyncgetData = async (url, isLoader = true) => {
    const loader = DefaultSettings.getLoader();
    loader && loader.add();
    try {
        const res = await fetch(`${url}`, {
            method: 'GET',
            headers: {
                'Authorization': getxAccessKey()
            }
        });
        if (res.ok) {
            loader && isLoader && loader.remove();
            return res.json();
        }
    } catch (ex) {
        loader && isLoader && loader.remove();
    }
};

export const Plugin_GetData = (url, alert = false, message = '', isLoader = true) => {
    const loader = DefaultSettings.getLoader();
    loader && isLoader && loader.add();
    return fetch(`${url}`, {
        method: 'GET',
        headers: getHeaders(url)
    }).then(response => handleResponse(response, url, alert, message, isLoader, Plugin_GetData))
      .catch(response => handleResponse(response, url, alert, message, isLoader, Plugin_GetData));
};

export const Plugin_PostData = (url, bodyval, alert = false, message) => {
    const loader = DefaultSettings.getLoader();
    loader && loader.add();
    return fetch(`${url}`, {
        method: 'POST',
        headers: getHeaders(url),
        body: JSON.stringify(bodyval)
    }).then(response => handleResponse(response, url, alert, message, true));
};

export const Plugin_PostDataNoBody = (url) => {
    const loader = DefaultSettings.getLoader();
    loader && loader.add();
    return fetch(`${url}`, {
        method: 'POST',
        headers: getHeaders(url)
    }).then(response => handleResponse(response, url, false, "Saved Successfully", true));
};

export const Plugin_PostFormData = (url, bodyval, alert = false) => {
    let formData = new URLSearchParams();
    Object.keys(bodyval).forEach(each => {
        formData.set(each, bodyval[each]);
    });
    const loader = DefaultSettings.getLoader();
    loader && loader.add();
    return fetch(`${url}`, {
        method: 'POST',
        headers: getHeaders(url, 'application/x-www-form-urlencoded'),
        body: formData
    }).then(response => handleResponse(response, url, alert, "Saved Successfully", true));
};

export const Plugin_PutData = (url, bodyval, alert = false) => {
    const loader = DefaultSettings.getLoader();
    loader && loader.add();
    return fetch(`${url}`, {
        method: 'PUT',
        headers: getHeaders(url),
        body: JSON.stringify(bodyval || {})
    }).then(response => handleResponse(response, url, alert, "Updated Successfully", true));
};

export const Plugin_PutFormData = (url, bodyval) => {
    let formData = new URLSearchParams();
    Object.keys(bodyval || {}).forEach(each => {
        formData.set(each, JSON.stringify(bodyval[each]));
    });
    const loader = DefaultSettings.getLoader();
    loader && loader.add();
    return fetch(`${url}`, {
        method: 'PUT',
        headers: getHeaders(url),
        body: JSON.stringify(bodyval || {})
    }).then(response => handleResponse(response, url, false, "Updated Successfully", true));
};

export const Plugin_DeleteRecord = (url, queryval = '') => {
    const loader = DefaultSettings.getLoader();
    loader && loader.add();
    return fetch(`${url + queryval}`, {
        method: 'DELETE',
        headers: getHeaders(url)
    }).then(response => handleResponse(response, url, false, "Deleted Successfully", true));
};

export const Plugin_OldPostMutiFormData = (url, bodyval, alert = false) => {
    const loader = DefaultSettings.getLoader();
    loader && loader.add();
    return fetch(`${url}`, {
        method: 'POST',
        headers: getHeaders(url),
        body: bodyval
    }).then(response => handleResponse(response, url, alert, "Saved Successfully", true));
};

export const Plugin_OldPutMutiFormData = (url, bodyval, alert = false) => {
    const loader = DefaultSettings.getLoader();
    loader && loader.add();
    return fetch(`${url}`, {
        method: 'PUT',
        headers: getHeaders(url),
        body: bodyval
    }).then(response => handleResponse(response, url, alert, "Saved Successfully", true));
};

export const Plugin_PostMutiFormData = (url, bodyval, alert = false) => {
    const loader = DefaultSettings.getLoader();
    loader && loader.add();
    return fetch(`${url}`, {
        method: 'POST',
        headers: getHeaders(url),
        body: bodyval
    }).then(response => handleResponse(response, url, alert, "Saved Successfully", true));
};